/**
 * @file サポーターの登録対象を変更したとき、サポートする隊のテキストを更新する
 *
 */
'use strict'

/**
 * @classname ChangeSupporterRegisteredAt
 * @classdesc サポーターの登録対象を変更したとき、サポートする隊のテキストを更新する
 */
export default class ChangeSupporterRegisteredAt {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.supporter-registered-at')
	 */
	constructor($e, controller) {
		console.log('ChangeSupporterRegisteredAt.constructor')
		this._$e = $e
		this._controller = controller
		this._$currentlySupportedDens = $('.currently-supported-dens')
		this._$currentlySupportedScouts = $('.currently-supported-scouts')
		this._$e.on('change', () => this.onChange())
		this.onChange()
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeSupporterRegisteredAt
	 * @return {undefined}
	 */
	onChange() {
		console.log('ChangeSupporterRegisteredAt.onChange')
		let dens = new Set()
		let scouts = new Set()
		$('.master_den_ids:not(.ignore-validate)').each((_, element) => {
			$(element).trigger('change').removeClass('is-invalid').closest('.form-group').find('.error-tip').removeClass('show')
			dens.add($(element).find('option:selected').text())
		})
		$('.scout_member_ids:not(.ignore-validate)').each((_, element) => {
			$(element).trigger('change').removeClass('is-invalid').closest('.form-group').find('.error-tip').removeClass('show')
			dens.add($(element).find('option:selected').data('den-name'))
			scouts.add($(element).find('option:selected').text())
		})
		dens.delete(undefined)
		dens.delete('選択')
		scouts.delete(undefined)
		scouts.delete('選択')
		let densText = ''
		Array.from(dens.keys()).forEach((key, index) => {
			densText += index ? ` / ${key}` : key
		})
		let scoutsText = ''
		Array.from(scouts.keys()).forEach((key, index) => {
			scoutsText += index ? ` / ${key}` : key
		})
		console.log(densText)
		console.log(scoutsText)
		this._$currentlySupportedDens.text(densText)
		this._$currentlySupportedScouts.text(scoutsText)
	}
}
